export default function HelpIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon / New / help_3">
        <path
          id="Combined Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6ZM6.78206 5.94009C6.8301 4.79897 7.22849 3.99019 7.97722 3.51372C8.44968 3.20942 9.03025 3.05728 9.71892 3.05728C10.6238 3.05728 11.3755 3.27349 11.9741 3.70591C12.5727 4.13833 12.872 4.77895 12.872 5.62778C12.872 6.14829 12.7419 6.58672 12.4816 6.94307C12.3295 7.15928 12.0372 7.43555 11.6048 7.77187L11.1783 8.1022C10.9461 8.28237 10.792 8.49258 10.7159 8.73281C10.6678 8.88496 10.6418 9.12119 10.6378 9.4415H9.01624C9.04026 8.76484 9.10432 8.29739 9.20842 8.03914C9.31252 7.78088 9.58079 7.48359 10.0132 7.14727L10.4516 6.80493C10.5958 6.69683 10.7119 6.57871 10.8 6.45059C10.9601 6.23037 11.0402 5.98813 11.0402 5.72388C11.0402 5.41958 10.9511 5.14231 10.7729 4.89207C10.5948 4.64182 10.2695 4.5167 9.797 4.5167C9.33254 4.5167 9.00322 4.67085 8.80903 4.97915C8.61484 5.28745 8.51775 5.60776 8.51775 5.94009H6.78206ZM8.97419 10.2643H10.7639V12H8.97419V10.2643Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
